import { toast } from 'react-hot-toast';

// Ref. documentation: https://react-hot-toast.com/
export const useToast = () => {
    const toastSuccess = (text: string) => {
        toast.success(text, { duration: 4000 });
    };
    const toastError = (text: string, duration?: number) => {
        if (duration) {
            toast.error(text, { duration });
        } else {
            toast.error(text);
        }
    };
    const toastInfo = (text: string, duration?: number, toastId?: string) => {
        toast(text, {
            icon: 'ℹ️',
            duration: duration ?? 6000,
            id: toastId,
        });
    };
    const dismissToast = (toastId?: string) => {
        toast.dismiss(toastId);
    };
    return { toastSuccess, toastError, toastInfo, dismissToast };
};
